let id = 100
export function createId() {
  id++
  return id
}

let _scene: Phaser.Scene | null = null
export function getPhaserScene(): Phaser.Scene {
  if (!_scene) {
    throw new Error('no scene')
  }
  return _scene
}
export function setPhaserScene(scene: Phaser.Scene) {
  _scene = scene
}

export function getGameSize() {
  let height = getPhaserScene().game.config.height as number
  let width = getPhaserScene().game.config.width as number
  return { width, height }
}

let _updateDeltaTime = 0
let _updateDeltaTimeScaled = 0
export function setUpdateDelta(updateTime: number) {
  _updateDeltaTime = updateTime
}
export function setUpdateDeltaScaled(updateTimeScaled: number) {
  _updateDeltaTimeScaled = updateTimeScaled
}
export function getUpdateDelta() {
  return _updateDeltaTime
}
export function getUpdateDeltaScaled() {
  return _updateDeltaTimeScaled
}
